export default __webpack_public_path__ + "static/media/audiov2_single_sided_demo.367657f9.mp4";